import { render, staticRenderFns } from "./dormMng.vue?vue&type=template&id=14621540&scoped=true"
import script from "./dormMng.vue?vue&type=script&lang=js"
export * from "./dormMng.vue?vue&type=script&lang=js"
import style0 from "./dormMng.vue?vue&type=style&index=0&id=14621540&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14621540",
  null
  
)

export default component.exports